import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdOutlineDashboard, MdPeople, MdAccessTime } from "react-icons/md";
import { FaSignOutAlt } from "react-icons/fa";
import { MdEventNote, MdPhotoCamera } from "react-icons/md";
import logo from "../Assets/dbskills-logo.webp";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  const menuItems = [
    { name: "Super Admin Dashboard", href: "/superadmin/dash", icon: MdOutlineDashboard, roles: ["superadmin"] },
    { name: "Dashboard",  href: "/dash",  icon: MdOutlineDashboard, roles: ["admin"] },
    { name: "Employees",  href: "/emp",   icon: MdPeople,            roles: ["admin"] },
    { name: "Attendance", href: "/atten", icon: MdAccessTime,        roles: ["admin"] },
    { name: "Leaves",     href: "/Leave", icon: MdEventNote,         roles: ["admin"] },
    { name: "Timestamps", href: "/timestamps", icon: MdPhotoCamera,   roles: ["superadmin"] },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');

        .sidebar-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #fff;
          border-right: 1px solid rgba(99,102,241,0.1);
          box-shadow: 4px 0 24px rgba(99,102,241,0.07);
        }

        /* Decorative mesh gradient blob */
        .sidebar-blob {
          position: absolute;
          top: -60px;
          right: -60px;
          width: 200px;
          height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(6,182,212,0.12) 0%, rgba(99,102,241,0.08) 60%, transparent 80%);
          pointer-events: none;
        }

        /* Logo area */
        .logo-wrap {
          position: relative;
          padding: 28px 24px 24px;
          background: linear-gradient(135deg, rgba(6,182,212,0.06) 0%, rgba(99,102,241,0.06) 100%);
          border-bottom: 1px solid rgba(99,102,241,0.08);
        }

        /* Section label */
        .nav-label {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          color: #94a3b8;
          padding: 0 16px;
          margin-bottom: 6px;
          text-transform: uppercase;
        }

        /* Nav item */
        .nav-item {
          position: relative;
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 11px 14px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          border: none;
          background: transparent;
          color: #64748b;
          transition: all 0.22s cubic-bezier(0.34,1.56,0.64,1);
          text-align: left;
          overflow: hidden;
        }

        .nav-item::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 12px;
          background: linear-gradient(135deg, rgba(6,182,212,0.08) 0%, rgba(99,102,241,0.08) 100%);
          opacity: 0;
          transition: opacity 0.2s ease;
        }

        .nav-item:hover::before { opacity: 1; }
        .nav-item:hover { color: #4f46e5; transform: translateX(3px); }

        .nav-item.active {
          background: linear-gradient(135deg, #06b6d4 0%, #6366f1 100%);
          color: #fff;
          box-shadow: 0 8px 20px rgba(99,102,241,0.28);
          transform: translateX(0);
        }
        .nav-item.active::before { display: none; }

        /* Icon box */
        .nav-icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 9px;
          flex-shrink: 0;
          transition: all 0.22s cubic-bezier(0.34,1.56,0.64,1);
          background: rgba(99,102,241,0.07);
        }
        .nav-item.active .nav-icon-box {
          background: rgba(255,255,255,0.2);
        }
        .nav-item:hover .nav-icon-box {
          transform: scale(1.12);
          background: rgba(99,102,241,0.12);
        }
        .nav-item.active:hover .nav-icon-box {
          background: rgba(255,255,255,0.25);
        }

        /* Active dot indicator */
        .active-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255,255,255,0.85);
          margin-left: auto;
          flex-shrink: 0;
          animation: dotPop 0.3s cubic-bezier(0.34,1.56,0.64,1);
        }
        @keyframes dotPop {
          from { transform: scale(0); opacity: 0; }
          to   { transform: scale(1); opacity: 1; }
        }

        /* Active left stripe */
        .nav-item.active::after {
          content: '';
          position: absolute;
          left: 0; top: 20%; bottom: 20%;
          width: 3px;
          border-radius: 0 3px 3px 0;
          background: rgba(255,255,255,0.5);
        }

        /* Divider */
        .sidebar-divider {
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(99,102,241,0.12), transparent);
          margin: 10px 16px;
        }

        /* Logout button */
        .logout-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 11px 14px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          border: none;
          background: transparent;
          color: #94a3b8;
          transition: all 0.22s cubic-bezier(0.34,1.56,0.64,1);
          text-align: left;
        }
        .logout-btn:hover {
          background: linear-gradient(135deg, rgba(239,68,68,0.08) 0%, rgba(244,63,94,0.06) 100%);
          color: #ef4444;
          transform: translateX(3px);
        }
        .logout-btn .nav-icon-box {
          background: rgba(239,68,68,0.07);
        }
        .logout-btn:hover .nav-icon-box {
          background: rgba(239,68,68,0.12);
          transform: scale(1.12);
        }

        /* Bottom user card */
        .user-card {
          margin: 0 12px 16px;
          padding: 12px 14px;
          border-radius: 14px;
          background: linear-gradient(135deg, rgba(6,182,212,0.07) 0%, rgba(99,102,241,0.07) 100%);
          border: 1px solid rgba(99,102,241,0.1);
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .user-avatar {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          background: linear-gradient(135deg, #06b6d4 0%, #6366f1 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 800;
          font-size: 14px;
          flex-shrink: 0;
        }

        /* Slide-in animation */
        .nav-list-item {
          animation: slideItem 0.4s ease both;
        }
        .nav-list-item:nth-child(1) { animation-delay: 0.05s; }
        .nav-list-item:nth-child(2) { animation-delay: 0.10s; }
        .nav-list-item:nth-child(3) { animation-delay: 0.15s; }
        .nav-list-item:nth-child(4) { animation-delay: 0.20s; }
        @keyframes slideItem {
          from { opacity: 0; transform: translateX(-12px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      {/* ── Sidebar panel ── */}
      <div
        className={`sidebar-root fixed top-0 left-0 z-50 h-screen w-64 flex flex-col
          transition-transform duration-300
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        {/* <div className="sidebar-blob" /> */}

        {/* Logo */}
        <div className="logo-wrap">
          <Link to="/" className="flex justify-center hover:opacity-80 transition-opacity">
            <img src={logo} alt="Logo" className="w-28 h-auto" />
          </Link>
          {/* Subtle tagline */}
          <p className="text-center text-xs text-indigo-400 font-semibold mt-2 tracking-wide">
            Admin Panel
          </p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto px-3 pt-6 pb-2">
          <p className="nav-label">Main Menu</p>

          <ul className="space-y-1">
            {menuItems
              .filter((item) => item.roles.includes(role))
              .map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.href;
                return (
                  <li key={item.name} className="nav-list-item">
                    <button
                      onClick={() => { setIsSidebarOpen(false); navigate(item.href); }}
                      className={`nav-item ${isActive ? "active" : ""}`}
                    >
                      <div className="nav-icon-box">
                        <Icon style={{ fontSize: 18 }} />
                      </div>
                      <span className="flex-1">{item.name}</span>
                      {isActive && <span className="active-dot" />}
                    </button>
                  </li>
                );
              })}
          </ul>

          <div className="sidebar-divider mt-4" />

          <p className="nav-label mt-4">Account</p>
          <ul className="space-y-1">
            <li className="nav-list-item">
              <button onClick={handleLogout} className="logout-btn">
                <div className="nav-icon-box">
                  <FaSignOutAlt style={{ fontSize: 16 }} />
                </div>
                <span className="flex-1">Logout</span>
              </button>
            </li>
          </ul>
        </nav>

        {/* Bottom user card */}
        <div className="user-card">
          <div className="user-avatar">A</div>
          <div className="min-w-0">
            <p className="text-xs font-bold text-gray-800 truncate">Administrator</p>
            <p className="text-xs text-indigo-400 font-semibold capitalize">{role || "admin"}</p>
          </div>
          <div className="ml-auto w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0" title="Online" />
        </div>
      </div>

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 bg-black/40 lg:hidden z-40 backdrop-blur-sm"
        />
      )}
    </>
  );
};

export default Sidebar;